import React                from 'react';
import PropTypes            from 'prop-types';
import PjaxWrapper          from '../../utils/PjaxWrapper';
import ReloadHelper         from '../../utils/ReloadHelper';
import NavBarNewIcon        from "./NavBarNewIcon";
import { trackNavbarClick } from '../../utils/GAHelper';

class NavBarDropdownElement extends React.PureComponent {

	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		if (this.props.scrollToTop) {
			PjaxWrapper.setTemporaryScrollToTop();
		}

		this.props.gaTracking && trackNavbarClick(this.props.parentName + '-' + this.props.gaTracking, this.props.link);

		ReloadHelper.reloadWithPjax(this.props.link, e);
	}

	render() {
		if (!this.props.caption) {
			return null;
		}

		let icon = '';
		if (this.props.iconClass) {
			const iconClass = this.props.iconClass + ' navbar__dropdown-icons';
			icon            = <i className={iconClass} />;
		}

		return (
			<li className={"dropdown-menu__item navbar__menu-item" + (this.props.isHighlighted ? ' is-active' : '') + (this.props.isNew ? ' h-flex -align-baseline' : '')}>
				<a className="a navbar__link" onClick={this.onClick} href={this.props.link}>
				{icon}{this.props.caption}
				{this.props.isNew && <NavBarNewIcon />}
				</a>
			</li>);

	}
}

NavBarDropdownElement.propTypes = {
	caption:       PropTypes.string,
	iconClass:     PropTypes.string,
	isNew:         PropTypes.bool,
	link:          PropTypes.string,
	scrollToTop:   PropTypes.bool,
	isHighlighted: PropTypes.bool,
	parentName:    PropTypes.string,
	gaTracking:    PropTypes.string,
};

NavBarDropdownElement.defaultProps = {
	iconClass:     '',
	isNew:         false,
	scrollToTop:   false,
	isHighlighted: false,
};

export default NavBarDropdownElement;
